var React = require('react');

function IconHeartSolidInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"m12.817 7.237-.817.82-.817-.82a4.197 4.197 0 0 0-5.95 0 4.233 4.233 0 0 0 0 5.972l.816.82 5.243 5.26a1 1 0 0 0 1.416 0l5.243-5.26.817-.82a4.233 4.233 0 0 0 0-5.972 4.197 4.197 0 0 0-5.951 0z","id":"a"})),React.createElement("use",{"xlinkHref":"#a","transform":"translate(-4 -6)","fill":"currentColor","key":1})]);
}

IconHeartSolidInline.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14"};

module.exports = IconHeartSolidInline;

IconHeartSolidInline.default = IconHeartSolidInline;
